module.exports = __webpack_public_path__ + "static/media/FEFRnature.f7a78681.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/FEFRnature.svg
// module id = 209
// module chunks = 0